var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          style: {
            "--popup-header-bg": _vm.headerColor.headerBg,
            "--popup-border-color": _vm.headerColor.headerBg,
          },
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            visible: _vm.messageDialog,
            "custom-class": "system-message-popup-dialog",
            top: "6vh",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.messageDialog = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "popup-header flx-between" }, [
                    _c("div", { staticClass: "popup-header__left" }, [
                      _c(
                        "span",
                        {
                          staticClass: "popup-header__icon",
                          style: { background: _vm.headerColor.color },
                        },
                        [
                          _c("img", {
                            staticClass: "popup-header__icon-img",
                            attrs: { src: _vm.headerIcon, alt: "" },
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "popup-header__title",
                          style: { color: _vm.titleColor },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.currentMessageObj.typeName || "系统消息"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        class: [
                          "popup-header__close",
                          { "is-disabled": _vm.isDisable },
                        ],
                        style: { color: _vm.titleColor },
                        on: { click: _vm.setClose },
                      },
                      [
                        _c("span", { staticClass: "iconfont icon-guanbi" }),
                        _vm.countdown > 0
                          ? _c(
                              "span",
                              { staticClass: "popup-header__countdown" },
                              [_vm._v(" (" + _vm._s(_vm.countdown) + "s) ")]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "popup-body" }, [
            _c("div", { staticClass: "popup-body__scroll" }, [
              _c("div", { staticClass: "popup-content" }, [
                _c("div", { staticClass: "popup-content__left" }, [
                  _c("div", { staticClass: "popup-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.currentMessageObj.title ||
                            _vm.currentMessageObj.zhTitle
                        ) +
                        " "
                    ),
                  ]),
                  _vm.currentMessageObj.abstract
                    ? _c("div", { staticClass: "popup-content__text" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.currentMessageObj.abstract || "") +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm.currentMessageObj.textUrl
                  ? _c("div", { staticClass: "popup-content__image" }, [
                      _c("img", {
                        attrs: { src: _vm.currentMessageObj.textUrl, alt: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.getImgSrc($event)
                          },
                        },
                      }),
                    ])
                  : _vm._e(),
              ]),
              _c("div", {
                staticClass: "popup-content__text",
                staticStyle: {
                  color: "black",
                  "font-size": "14px",
                  "margin-top": "12px",
                },
                domProps: {
                  innerHTML: _vm._s(_vm.currentMessageObj.text || ""),
                },
              }),
            ]),
            _c("div", { staticClass: "popup-footer" }, [
              _c("i", { staticClass: "el-icon-time" }),
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("trajectory.PublishTime")) +
                    "：" +
                    _vm._s(_vm.currentMessageObj.createTime || "")
                ),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "popup-action" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { disabled: _vm.isDisable, size: "small" },
                  on: { click: _vm.setClose },
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.close")) + " "),
                  _vm.countdown > 0
                    ? _c("span", { staticClass: "popup-action__countdown" }, [
                        _vm._v("(" + _vm._s(_vm.countdown) + "s)"),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm.showViewer
        ? _c("ElImageViewer", {
            attrs: { "on-close": _vm.closeViewer, "url-list": _vm.imgArr },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }